import React from "react";

import { LegacyMacroRenderer } from "@confluence/fabric-extension-legacy-macro-renderer";
import {
  CreateFromTemplateLoader,
  LazyCreateFromTemplateLoader,
} from "@confluence/create-from-template";

export const CreateFromTemplateHandler = ({
  adf,
  macroDefaultProps,
  cloudId,
  userId,
  isPreviewMode,
  contentType,
  shouldLoadAfterPaint,
}) => {
  if (!adf) {
    return <LegacyMacroRenderer {...macroDefaultProps} />;
  }

  return shouldLoadAfterPaint || isPreviewMode ? (
    <LazyCreateFromTemplateLoader
      userId={userId}
      cloudId={cloudId}
      adf={adf}
      macroDefaultProps={macroDefaultProps}
      isPreviewMode={isPreviewMode}
      contentType={contentType}
    />
  ) : (
    <CreateFromTemplateLoader
      userId={userId}
      cloudId={cloudId}
      adf={adf}
      macroDefaultProps={macroDefaultProps}
      isPreviewMode={isPreviewMode}
      contentType={contentType}
    />
  );
};
